/** @format */

import {WIDGETS_LIST} from '../constants/widgets';

interface ChartWithOrder {
  chartId: string;
  order?: number;
  chartOrder?: number;
}

export interface MultilineChartsWithOrders {
  charts: ChartWithOrder[];
}

/**
 * Сортирует графики по полям order и chartOrder из WIDGETS_LIST.
 * order: Чем больше число, тем ближе к началу.
 * chartOrder: Чем больше число, тем ближе к концу.
 * @param data
 */

const sortCharts = <V extends MultilineChartsWithOrders>(data: V): V => {
  const sortedCharts = data.charts.toSorted((a, b) => {
    const widgetA = WIDGETS_LIST[a.chartId];
    const widgetB = WIDGETS_LIST[b.chartId];
    const orderA = widgetA.order ?? 0;
    const orderB = widgetB.order ?? 0;
    const chartOrderA = widgetA.chartOrder ?? 0;
    const chartOrderB = widgetB.chartOrder ?? 0;
    if (chartOrderA < chartOrderB) return -1;
    if (chartOrderA > chartOrderB) return 1;
    if (orderA > orderB) return -1;
    if (orderA < orderB) return 1;
    return 0;
  });

  return {
    ...data,
    charts: sortedCharts,
  };
};

export {sortCharts};
